// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate, useSearchParams } from "react-router-dom";
// import UserConfigModal from "./UserConfigModal";
// import DashboardContent from "./DashboardContent";
// import EmailPreview from "./EmailPreview";
// import ReplyEmail from "./ReplyEmail";
// import { useEmails } from "../../providers/EmailsContext";
// import { useAuth } from "../../providers/AuthContext";
// import { ErrorBoundary } from "./ErrorBoundary";
// import DashboardLayout from "../../layout/DashboardLayout";
// import Cookies from "js-cookie";

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const { emailId } = useParams();
//   const [searchParams] = useSearchParams();
//   const { user } = useAuth();
//   const { emails, showConfigModal, setShowConfigModal } = useEmails();
//   const [accessToken, setAccessToken] = useState(
//     () => Cookies.get("access_token") || null
//   );

//   const [selectedEmail, setSelectedEmail] = useState(null);
//   const [isReplying, setIsReplying] = useState(false);
//   // const [showConfigModal, setShowConfigModal] = useState(false);
//   const [apiConfigError, setApiConfigError] = useState(false);
//   const [configModalClosed, setConfigModalClosed] = useState(false);

//   // Find email by ID when emailId changes
//   useEffect(() => {
//     if (emailId && emails) {
//       // Find the email in all categories
//       const categories = ["needs_response", "spam", "notify"];
//       for (const category of categories) {
//         const foundEmail = emails[category]?.find(
//           (email) => email.email.id === emailId
//         );
//         if (foundEmail) {
//           setSelectedEmail(foundEmail);
//           break;
//         }
//       }
//     }
//   }, [emailId, emails]);

//   const handleEmailSelect = (email) => {
//     if (selectedEmail && selectedEmail.email.id === email.email.id) {
//       setSelectedEmail(null);
//       navigate("/dashboard");
//     } else {
//       setSelectedEmail(email);
//       navigate(`/email/reply/${email.email.id}`);
//     }
//   };

//   const handleBackToInbox = () => {
//     setSelectedEmail(null);
//     setIsReplying(false);
//     navigate("/dashboard");
//   };

//   const handleReply = () => {
//     setIsReplying(true);
//   };

//   const handleCloseReply = () => {
//     setIsReplying(false);
//   };

//   const handleConfigSaved = () => {
//     setShowConfigModal(false);
//     setConfigModalClosed(true);
//     sessionStorage.removeItem("oauth_signup");
//   };

//   // Check for OAuth redirect and show config modal if needed
//   const newUserLogin = sessionStorage.getItem("new_user_signup") === "true";
//   useEffect(() => {
//     if (newUserLogin) {
//       setShowConfigModal(true);
//       sessionStorage.setItem("oauth_signup", "true");
//     }
//   }, [searchParams, newUserLogin]);

//   useEffect(() => {
//     const handleOAuthRedirect = async () => {
//       // Check if we have tokens directly in the URL (this happens with certain URL patterns)
//       const urlParams = new URLSearchParams(window.location.search);
//       const accessToken =
//         urlParams.get("access_token") || searchParams.get("access_token");
//       const refreshToken =
//         urlParams.get("refresh_token") || searchParams.get("refresh_token");
//       const provider =
//         urlParams.get("provider") || searchParams.get("provider");
//       const userId = urlParams.get("user_id") || searchParams.get("user_id");
//       const accountId =
//         urlParams.get("account_id") || searchParams.get("account_id");
//       const isNewUser =
//         urlParams.get("is_new_user") || searchParams.get("is_new_user");

//       if (isNewUser) {
//         sessionStorage.setItem("new_user_signup", "true");
//       }

//       // Extra check for tokens in the hash part of the URL (some OAuth flows use this)
//       if (!accessToken && window.location.hash) {
//         const hashParams = new URLSearchParams(
//           window.location.hash.substring(1)
//         );
//         const hashAccessToken = hashParams.get("access_token");
//         if (hashAccessToken) {
//           // If found in hash, use those values
//           accessToken = hashAccessToken;
//           refreshToken = hashParams.get("refresh_token");
//           // Can extract other params if needed
//         }
//       }

//       if (accessToken) {
//         console.log("OAuth redirect detected, storing authentication tokens");

//         try {
//           // Check if we already have valid cookies
//           const existingToken = Cookies.get("access_token");
//           if (existingToken) {
//             console.log(
//               "Tokens already exist in cookies, skipping token storage"
//             );
//             setAccessToken(existingToken);
//             // Make sure AUTH_STATUS_CHANGED is defined or use a string constant
//             window.dispatchEvent(new CustomEvent("AUTH_STATUS_CHANGED"));

//             // Clean up URL params
//             cleanupUrlParams();
//             return;
//           }

//           // No need to validate the token format if we're just passing it through
//           // Just store the token as is
//           Cookies.set("access_token", accessToken, {
//             expires: 10 / 24, // 10 hours in days
//             path: "/",
//             sameSite: "lax",
//             secure: window.location.protocol === "https:",
//           });

//           // Set the access token in the state
//           setAccessToken(accessToken);

//           // Store refresh token if present
//           if (refreshToken) {
//             Cookies.set("refresh_token", refreshToken, {
//               expires: 10 / 24,
//               path: "/",
//               sameSite: "lax",
//               secure: window.location.protocol === "https:",
//             });
//           }

//           // Store user_id if present
//           if (userId) {
//             Cookies.set("user_id", userId, {
//               expires: 10 / 24,
//               path: "/",
//               sameSite: "lax",
//               secure: window.location.protocol === "https:",
//             });
//           }

//           // Store account_id if present
//           if (accountId && accountId !== "None") {
//             Cookies.set("account_id", accountId, {
//               expires: 10 / 24,
//               path: "/",
//               sameSite: "lax",
//               secure: window.location.protocol === "https:",
//             });
//           }

//           // Store provider if present
//           if (provider) {
//             Cookies.set("provider", provider, {
//               expires: 10 / 24,
//               path: "/",
//               sameSite: "lax",
//               secure: window.location.protocol === "https:",
//             });
//           }

//           console.log("Successfully stored all tokens");

//           // Dispatch event to trigger immediate data fetch
//           window.dispatchEvent(new CustomEvent("AUTH_STATUS_CHANGED"));

//           // If fetchUserData is defined in this scope
//           if (typeof fetchUserData === "function") {
//             await fetchUserData(true);
//           }

//           // Clean up URL params
//           // cleanupUrlParams();
//         } catch (error) {
//           console.error("Error handling OAuth redirect:", error);
//           // Make sure toast is defined or use window.alert
//           if (typeof toast !== "undefined") {
//             toast.error("Failed to complete authentication. Please try again.");
//           } else {
//             console.error("Authentication failed. Please try again.");
//           }
//           navigate("/");
//         }
//       }
//     };

//     const cleanupUrlParams = () => {
//       // Clean up URL params but keep new_oauth_login if present
//       navigate("/dashboard", { replace: true });
//     };

//     handleOAuthRedirect();
//   }, [searchParams, navigate]);

//   return (
//     <>
//       {showConfigModal && (
//         <ErrorBoundary>
//           <UserConfigModal
//             onConfigSaved={handleConfigSaved}
//             userId={user?.id}
//           />
//         </ErrorBoundary>
//       )}

//       <DashboardLayout>
//         {/* API Config Error Banner */}
//         {apiConfigError && (
//           <div className="mb-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded shadow-sm">
//             <div className="flex">
//               <div className="py-1 mr-3">
//                 <svg
//                   className="w-6 h-6 text-yellow-500"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
//                   ></path>
//                 </svg>
//               </div>
//               <div>
//                 <p className="font-bold">API Configuration Needed</p>
//                 <p className="text-sm">
//                   Please configure your email provider API settings to enable
//                   all features.
//                 </p>
//                 <button
//                   onClick={() => setShowConfigModal(true)}
//                   className="mt-1 px-3 py-1 bg-yellow-500 text-white text-xs rounded hover:bg-yellow-600 focus:outline-none"
//                 >
//                   Configure Now
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Show email reply, email preview, or dashboard content */}
//         {isReplying && selectedEmail ? (
//           <ErrorBoundary>
//             <ReplyEmail
//               email={selectedEmail}
//               onClose={handleCloseReply}
//               isReplying={true}
//             />
//           </ErrorBoundary>
//         ) : selectedEmail ? (
//           <ErrorBoundary>
//             <EmailPreview
//               email={selectedEmail}
//               onBack={handleBackToInbox}
//               onReply={handleReply}
//             />
//           </ErrorBoundary>
//         ) : (
//           <ErrorBoundary>
//             <DashboardContent
//               onEmailSelect={handleEmailSelect}
//               configModalClosed={configModalClosed}
//             />
//           </ErrorBoundary>
//         )}
//       </DashboardLayout>
//     </>
//   );
// };

// export default Dashboard;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import UserConfigModal from "./UserConfigModal";
import DashboardContent from "./DashboardContent";
import EmailPreview from "./EmailPreview";
import ReplyEmail from "./ReplyEmail";
import { useEmails } from "../../providers/EmailsContext";
import { useAuth } from "../../providers/AuthContext";
import { ErrorBoundary } from "./ErrorBoundary";
import DashboardLayout from "../../layout/DashboardLayout";
import Cookies from "js-cookie";

const Dashboard = () => {
  const navigate = useNavigate();
  const { emailId } = useParams();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const { emails, showConfigModal, setShowConfigModal } = useEmails();

  // ✅ FIXED: Initialize modal state from localStorage to persist across refreshes and browser sessions
  const [localShowConfigModal, setLocalShowConfigModal] = useState(() => {
    return localStorage.getItem("new_user_signup") === "true";
  });
  const [accessToken, setAccessToken] = useState(
    () => Cookies.get("access_token") || null
  );

  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isReplying, setIsReplying] = useState(false);
  const [apiConfigError, setApiConfigError] = useState(false);
  const [configModalClosed, setConfigModalClosed] = useState(false);

  // Find email by ID when emailId changes
  useEffect(() => {
    if (emailId && emails) {
      // Find the email in all categories
      const categories = ["needs_response", "spam", "notify"];
      for (const category of categories) {
        const foundEmail = emails[category]?.find(
          (email) => email.email.id === emailId
        );
        if (foundEmail) {
          setSelectedEmail(foundEmail);
          break;
        }
      }
    }
  }, [emailId, emails]);

  const handleEmailSelect = (email) => {
    if (selectedEmail && selectedEmail.email.id === email.email.id) {
      setSelectedEmail(null);
      navigate("/dashboard");
    } else {
      setSelectedEmail(email);
      navigate(`/email/reply/${email.email.id}`);
    }
  };

  const handleBackToInbox = () => {
    setSelectedEmail(null);
    setIsReplying(false);
    navigate("/dashboard");
  };

  const handleReply = () => {
    setIsReplying(true);
  };

  const handleCloseReply = () => {
    setIsReplying(false);
  };

  const handleConfigSaved = () => {
    setShowConfigModal(false);
    setLocalShowConfigModal(false); // ✅ Also update local state
    setConfigModalClosed(true);
    localStorage.removeItem("oauth_signup"); // ✅ Changed to localStorage
    localStorage.removeItem("new_user_signup"); // ✅ Changed to localStorage
  };

  // ✅ NEW: Check for new user from localStorage (email/password registration)
  useEffect(() => {
    const checkNewUserFromLocalStorage = () => {
      const isNewUserFromStorage = localStorage.getItem("new_user_signup");

      console.log("Checking localStorage for new user:", {
        isNewUserFromStorage: isNewUserFromStorage,
        showConfigModal: showConfigModal,
      });

      // If user is marked as new in localStorage and modal isn't already shown
      if (
        isNewUserFromStorage === "true" &&
        !showConfigModal &&
        !localShowConfigModal
      ) {
        console.log(
          "New user detected from localStorage, showing config modal"
        );
        setShowConfigModal(true);
        setLocalShowConfigModal(true); // ✅ Also set local state
      }
    };

    // Only run this check after component mounts and user is available
    if (user) {
      checkNewUserFromLocalStorage();
    }
  }, [user, showConfigModal, localShowConfigModal, setShowConfigModal]);

  // ✅ FIXED: Check for OAuth redirect and show config modal ONLY for new users
  useEffect(() => {
    const handleOAuthRedirect = async () => {
      // Check if we have tokens directly in the URL
      const urlParams = new URLSearchParams(window.location.search);
      const accessToken =
        urlParams.get("access_token") || searchParams.get("access_token");
      const refreshToken =
        urlParams.get("refresh_token") || searchParams.get("refresh_token");
      const provider =
        urlParams.get("provider") || searchParams.get("provider");
      const userId = urlParams.get("user_id") || searchParams.get("user_id");
      const accountId =
        urlParams.get("account_id") || searchParams.get("account_id");

      // ✅ FIXED: Get is_new_user from URL parameters
      const isNewUser =
        urlParams.get("is_new_user") || searchParams.get("is_new_user");

      console.log("OAuth redirect check:", {
        hasAccessToken: !!accessToken,
        isNewUser: isNewUser,
        isNewUserBoolean: isNewUser === "true",
      });

      // ✅ FIXED: Only show config modal if is_new_user is explicitly "true"
      if (isNewUser === "true") {
        console.log("New user detected from OAuth, setting up config modal");
        localStorage.setItem("new_user_signup", "true"); // ✅ Changed to localStorage
        setShowConfigModal(true);
        setLocalShowConfigModal(true); // ✅ Also set local state
        localStorage.setItem("oauth_signup", "true"); // ✅ Changed to localStorage
      } else {
        console.log("Existing user from OAuth, not showing config modal");
        // Clear any existing new user flags for OAuth users
        if (accessToken) {
          localStorage.removeItem("new_user_signup"); // ✅ Changed to localStorage
          localStorage.removeItem("oauth_signup"); // ✅ Changed to localStorage
          setLocalShowConfigModal(false); // ✅ Also clear local state
        }
      }

      // Extra check for tokens in the hash part of the URL (some OAuth flows use this)
      if (!accessToken && window.location.hash) {
        const hashParams = new URLSearchParams(
          window.location.hash.substring(1)
        );
        const hashAccessToken = hashParams.get("access_token");
        if (hashAccessToken) {
          // If found in hash, use those values
          accessToken = hashAccessToken;
          refreshToken = hashParams.get("refresh_token");
          // Can extract other params if needed
        }
      }

      if (accessToken) {
        console.log("OAuth redirect detected, storing authentication tokens");

        try {
          // Check if we already have valid cookies
          const existingToken = Cookies.get("access_token");
          if (existingToken && existingToken === accessToken) {
            console.log(
              "Same token already exists in cookies, skipping token storage"
            );
            setAccessToken(existingToken);
            window.dispatchEvent(new CustomEvent("AUTH_STATUS_CHANGED"));

            // Clean up URL params
            cleanupUrlParams();
            return;
          }

          // Store the new token
          Cookies.set("access_token", accessToken, {
            expires: 10 / 24, // 10 hours in days
            path: "/",
            sameSite: "lax",
            secure: window.location.protocol === "https:",
          });

          // Set the access token in the state
          setAccessToken(accessToken);

          // Store refresh token if present
          if (refreshToken) {
            Cookies.set("refresh_token", refreshToken, {
              expires: 10 / 24,
              path: "/",
              sameSite: "lax",
              secure: window.location.protocol === "https:",
            });
          }

          // Store user_id if present
          if (userId) {
            Cookies.set("user_id", userId, {
              expires: 10 / 24,
              path: "/",
              sameSite: "lax",
              secure: window.location.protocol === "https:",
            });
          }

          // Store account_id if present
          if (accountId && accountId !== "None") {
            Cookies.set("account_id", accountId, {
              expires: 10 / 24,
              path: "/",
              sameSite: "lax",
              secure: window.location.protocol === "https:",
            });
          }

          // Store provider if present
          if (provider) {
            Cookies.set("provider", provider, {
              expires: 10 / 24,
              path: "/",
              sameSite: "lax",
              secure: window.location.protocol === "https:",
            });
          }

          console.log("Successfully stored all tokens");

          // Dispatch event to trigger immediate data fetch
          window.dispatchEvent(new CustomEvent("AUTH_STATUS_CHANGED"));

          // If fetchUserData is defined in this scope
          if (typeof fetchUserData === "function") {
            await fetchUserData(true);
          }

          // Clean up URL params after a short delay
          setTimeout(() => {
            cleanupUrlParams();
          }, 1000);
        } catch (error) {
          console.error("Error handling OAuth redirect:", error);
          // Make sure toast is defined or use window.alert
          if (typeof toast !== "undefined") {
            toast.error("Failed to complete authentication. Please try again.");
          } else {
            console.error("Authentication failed. Please try again.");
          }
          navigate("/");
        }
      }
    };

    const cleanupUrlParams = () => {
      // Clean up URL params and navigate to clean dashboard
      navigate("/dashboard", { replace: true });
    };

    handleOAuthRedirect();
  }, [searchParams, navigate, setShowConfigModal]);

  return (
    <>
      {(showConfigModal || localShowConfigModal) && (
        <ErrorBoundary>
          <UserConfigModal
            onConfigSaved={handleConfigSaved}
            userId={user?.id}
          />
        </ErrorBoundary>
      )}

      <DashboardLayout>
        {/* API Config Error Banner */}
        {apiConfigError && (
          <div className="mb-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded shadow-sm">
            <div className="flex">
              <div className="py-1 mr-3">
                <svg
                  className="w-6 h-6 text-yellow-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  ></path>
                </svg>
              </div>
              <div>
                <p className="font-bold">API Configuration Needed</p>
                <p className="text-sm">
                  Please configure your email provider API settings to enable
                  all features.
                </p>
                <button
                  onClick={() => {
                    setShowConfigModal(true);
                    setLocalShowConfigModal(true); // ✅ Also set local state
                  }}
                  className="mt-1 px-3 py-1 bg-yellow-500 text-white text-xs rounded hover:bg-yellow-600 focus:outline-none"
                >
                  Configure Now
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Show email reply, email preview, or dashboard content */}
        {isReplying && selectedEmail ? (
          <ErrorBoundary>
            <ReplyEmail
              email={selectedEmail}
              onClose={handleCloseReply}
              isReplying={true}
            />
          </ErrorBoundary>
        ) : selectedEmail ? (
          <ErrorBoundary>
            <EmailPreview
              email={selectedEmail}
              onBack={handleBackToInbox}
              onReply={handleReply}
            />
          </ErrorBoundary>
        ) : (
          <ErrorBoundary>
            <DashboardContent
              onEmailSelect={handleEmailSelect}
              configModalClosed={configModalClosed}
            />
          </ErrorBoundary>
        )}
      </DashboardLayout>
    </>
  );
};

export default Dashboard;
